import { ProfileMenuController } from './controllers/ProfileMenuController.js';
import { ProfileForumTopicController } from './controllers/ProfileForumTopicController.js';
import { ProfileFeedbackController } from './controllers/ProfileFeedbackController.js';
import { ProfileLotController } from './controllers/ProfileLotController.js';
import { ProfilePublicationController } from './controllers/ProfilePublicationController.js';
import { BasePage } from '../../base/BasePage.js';

export class ProfilePage extends BasePage {
    constructor() {

        super();

        const token = window.appData?.token;
        const authorId = window.appData?.authorId;
        const locale = window.appData?.locale;


        this.initResource({
            controller: new ProfileMenuController(),
            event: 'profile.menu',
            cacheKey: `profile.menu.${authorId}`,
            payload: { token, locale, authorId }
        });

        this.initResource({
            controller: new ProfileForumTopicController(),
            event: 'profile.lastForumTopics',
            cacheKey: `profile.lastForumTopics.${authorId}`,
            payload: { token, locale, authorId }
        });

        this.initResource({
            controller: new ProfileFeedbackController(),
            event: 'profile.lastFeedbacks',
            cacheKey: `profile.lastFeedbacks.${authorId}`,
            payload: { token, locale, authorId }
        });

        this.initResource({
            controller: new ProfileLotController(),
            event: 'profile.lastLots',
            cacheKey: `profile.lastLots.${authorId}`,
            payload: { token, locale, authorId }
        });

        this.initResource({
            controller: new ProfilePublicationController(),
            event: 'profile.lastPublications',
            cacheKey: `profile.lastPublications.${authorId}`,
            payload: { token, locale, authorId }
        });
    }
}